import { createStore, applyMiddleware } from 'redux'
import { createLogger } from 'redux-logger'
import ReduxThunk from 'redux-thunk'
import reducers from './reducers'

const logger = createLogger()
const store = createStore(reducers, applyMiddleware(logger, ReduxThunk))

export default store;


// WEBPACK FOOTER //
// ./src/store.js